import { SIDEBAR_TOGGLE } from './reduxConstant';

export const sidebarToggleAction = (isShrunk) => ({
  type: SIDEBAR_TOGGLE,
  payload: { isShrunk },
});
